import * as React from "react";

const GooglePlayIcon = (props) => (
    <svg
        width={112}
        height={32}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M107.29.641c1.896 0 3.44 1.507 3.44 3.359v24c0 1.852-1.544 3.359-3.44 3.359H4.866c-1.896 0-3.44-1.507-3.44-3.359V4c0-1.852 1.544-3.359 3.44-3.359H107.29Zm0-.641H4.866C2.614 0 .77 1.801.77 4v24c0 2.199 1.844 4 4.096 4H107.29c2.252 0 4.097-1.801 4.097-4V4c0-2.199-1.845-4-4.097-4Z"
            fill="#A6A6A6"
        />
        <path
            d="M39.624 8.195c0 .668-.205 1.203-.608 1.602-.465.473-1.069.711-1.81.711A2.516 2.516 0 0 1 35.4 9.79c-.497-.484-.745-1.078-.745-1.789 0-.71.248-1.305.745-1.785a2.504 2.504 0 0 1 1.808-.723c.352 0 .688.071 1.008.203.32.133.58.313.769.535l-.428.422c-.33-.379-.777-.566-1.35-.566-.516 0-.963.176-1.343.531-.376.356-.565.817-.565 1.383 0 .566.189 1.031.565 1.387.38.351.828.531 1.344.531.548 0 1.009-.18 1.372-.535.24-.235.376-.559.412-.973h-1.784v-.578h2.38c.029.125.037.246.037.363ZM43.398 6.19h-2.236v1.52h2.016v.579h-2.016v1.52h2.236v.589H40.53V5.602h2.87v.589ZM46.065 10.398h-.633V6.19H44.06V5.6h3.377v.59h-1.372v4.207ZM49.879 10.398V5.602h.632v4.796h-.632ZM53.315 10.398h-.628V6.19H51.31V5.6h3.381v.59h-1.376v4.207ZM61.083 9.781c-.484.485-1.084.727-1.8.727-.72 0-1.32-.242-1.805-.727-.483-.484-.724-1.078-.724-1.78 0-.704.24-1.298.724-1.782.484-.485 1.085-.727 1.805-.727.712 0 1.312.242 1.796.731.488.488.728 1.078.728 1.777 0 .703-.24 1.297-.724 1.781Zm-3.137-.402a1.83 1.83 0 0 0 1.337.54c.524 0 .972-.18 1.332-.54.364-.359.548-.82.548-1.379s-.184-1.02-.548-1.379a1.821 1.821 0 0 0-1.332-.539c-.529 0-.972.18-1.337.54-.363.358-.548.82-.548 1.378 0 .56.184 1.02.548 1.38ZM62.695 10.398V5.602h.769l2.388 3.73h.028l-.028-.922V5.602h.632v4.796h-.66l-2.5-3.914h-.029l.028.926v2.988h-.628Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.16}
            strokeMiterlimit={10}
        />
        <path
            d="M56.598 17.402c-1.925 0-3.497 1.43-3.497 3.403 0 1.957 1.572 3.402 3.497 3.402 1.928 0 3.5-1.445 3.5-3.402 0-1.973-1.572-3.403-3.5-3.403Zm0 5.465c-1.056 0-1.965-.851-1.965-2.062 0-1.227.909-2.063 1.965-2.063s1.968.836 1.968 2.063c0 1.21-.912 2.062-1.968 2.062Zm-7.63-5.465c-1.928 0-3.497 1.43-3.497 3.403 0 1.957 1.569 3.402 3.497 3.402s3.497-1.445 3.497-3.402c0-1.973-1.57-3.403-3.497-3.403Zm0 5.465c-1.057 0-1.968-.851-1.968-2.062 0-1.227.911-2.063 1.968-2.063 1.056 0 1.965.836 1.965 2.063 0 1.21-.909 2.062-1.965 2.062Zm-9.079-4.422v1.446h3.537c-.103.808-.38 1.402-.804 1.816-.516.5-1.32 1.055-2.733 1.055-2.176 0-3.88-1.715-3.88-3.84s1.704-3.84 3.88-3.84c1.177 0 2.033.449 2.665 1.03l1.044-1.018c-.884-.824-2.06-1.457-3.709-1.457-2.984 0-5.492 2.37-5.492 5.285 0 2.914 2.508 5.285 5.492 5.285 1.614 0 2.825-.516 3.778-1.484.976-.953 1.28-2.293 1.28-3.375 0-.336-.029-.645-.08-.903H39.89Zm37.125 1.12c-.288-.76-1.176-2.163-2.985-2.163-1.792 0-3.285 1.379-3.285 3.403 0 1.906 1.477 3.402 3.457 3.402 1.601 0 2.525-.953 2.905-1.508l-1.188-.773c-.397.566-.936.94-1.717.94-.775 0-1.331-.346-1.688-1.03l4.661-1.883-.16-.387ZM72.26 20.7a1.887 1.887 0 0 1 1.82-1.984c.609 0 1.125.297 1.297.722l-3.117 1.262Zm-3.788 3.3h1.532V14h-1.532v10Zm-2.51-5.84h-.05c-.345-.397-1.002-.757-1.833-.757-1.746 0-3.341 1.496-3.341 3.414 0 1.907 1.595 3.39 3.34 3.39.832 0 1.489-.362 1.833-.772h.051v.488c0 1.3-.712 2-1.86 2-.936 0-1.517-.66-1.756-1.215l-1.333.543a3.324 3.324 0 0 0 3.09 2.012c1.796 0 3.312-1.032 3.312-3.543v-6.11h-1.453v.55Zm-1.752 4.708c-1.056 0-1.94-.863-1.94-2.051 0-1.2.884-2.074 1.94-2.074 1.04 0 1.86.875 1.86 2.074 0 1.188-.82 2.05-1.86 2.05ZM84.187 14h-3.664v10h1.528v-3.79h2.136c1.698 0 3.362-1.198 3.362-3.105 0-1.906-1.669-3.105-3.362-3.105Zm.04 4.82h-2.176v-3.43h2.176c1.141 0 1.793.926 1.793 1.715 0 .774-.652 1.715-1.793 1.715Zm9.447-1.437c-1.104 0-2.252.476-2.725 1.53l1.356.556c.292-.555.83-.735 1.396-.735.793 0 1.597.465 1.61 1.286v.105c-.277-.156-.869-.387-1.597-.387-1.46 0-2.949.785-2.949 2.25 0 1.34 1.196 2.203 2.541 2.203 1.029 0 1.596-.453 1.952-.98h.053v.773h1.475v-3.836c0-1.773-1.356-2.765-3.112-2.765Zm-.184 5.48c-.5 0-1.197-.242-1.197-.847 0-.774.869-1.071 1.62-1.071.673 0 .989.145 1.398.336-.12.926-.937 1.582-1.822 1.582Zm8.674-5.261-1.757 4.335h-.052l-1.816-4.335H96.89l2.728 6.058-1.556 3.37h1.596l4.205-9.428h-1.7ZM88.389 24h1.532V14H88.39v10Z"
            fill="#fff"
        />
        <path
            d="M9.321 6.03c-.24.246-.38.63-.38 1.125v17.692c0 .496.14.88.38 1.125l.06.054 10.154-9.91v-.234L9.381 5.972l-.06.058Z"
            fill="url(#a)"
        />
        <path
            d="m22.916 19.422-3.38-3.305v-.234l3.384-3.305.076.043 4.009 2.227c1.144.632 1.144 1.672 0 2.308l-4.009 2.223-.08.043Z"
            fill="url(#b)"
        />
        <path
            d="M22.995 19.379 19.534 16 9.32 25.973c.38.39 1 .437 1.705.047l11.97-6.641Z"
            fill="url(#c)"
        />
        <path
            d="M22.995 12.621 11.025 5.98c-.705-.386-1.325-.339-1.705.051L19.534 16l3.46-3.379Z"
            fill="url(#d)"
        />
        <defs>
            <linearGradient
                id="a"
                x1={18.634}
                y1={25.032}
                x2={5.211}
                y2={11.284}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00A0FF" />
                <stop offset={0.007} stopColor="#00A1FF" />
                <stop offset={0.26} stopColor="#00BEFF" />
                <stop offset={0.512} stopColor="#00D2FF" />
                <stop offset={0.76} stopColor="#00DFFF" />
                <stop offset={1} stopColor="#00E3FF" />
            </linearGradient>
            <linearGradient
                id="b"
                x1={28.495}
                y1={15.999}
                x2={8.668}
                y2={15.999}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFE000" />
                <stop offset={0.409} stopColor="#FFBD00" />
                <stop offset={0.775} stopColor="orange" />
                <stop offset={1} stopColor="#FF9C00" />
            </linearGradient>
            <linearGradient
                id="c"
                x1={21.113}
                y1={14.163}
                x2={2.911}
                y2={-4.479}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF3A44" />
                <stop offset={1} stopColor="#C31162" />
            </linearGradient>
            <linearGradient
                id="d"
                x1={6.749}
                y1={31.859}
                x2={14.877}
                y2={23.534}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#32A071" />
                <stop offset={0.069} stopColor="#2DA771" />
                <stop offset={0.476} stopColor="#15CF74" />
                <stop offset={0.801} stopColor="#06E775" />
                <stop offset={1} stopColor="#00F076" />
            </linearGradient>
        </defs>
    </svg>
);

export default GooglePlayIcon;
